import Budgets from "../Components/Budgets";

function Index() {
  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold mb-4">All Transactions</h1>
      <Budgets />
    </div>
  );
}

export default Index;
